import styled, { css } from 'styled-components';

import { ButtonWithoutBackground } from '@comeon/ui';

export const ChangeMethodContainer = styled.div`
	align-items: flex-start;
	display: flex;
	flex-direction: column;
	gap: 12px;
	justify-content: center;
	width: 100%;
`;

export const MethodsCollapse = styled.div<{ toggle: boolean; items: number }>`
	border-radius: 6px;
	overflow: hidden;
	transition: all 0.3s ease-out;
	width: 100%;

	${({ toggle, items }) =>
		toggle
			? css`
					height: ${items * 47}px;
					visibility: visible;
				`
			: css`
					height: 0;
					visibility: hidden;
				`};
`;

export const MethodsCollapseTitle = styled(ButtonWithoutBackground)`
	align-items: center;
	color: var(--new-qd--change-method-color);
	display: flex;
	font: var(--label-bold);
	gap: 4px;
	justify-content: flex-start;
	padding: 0;
	width: fit-content;

	span {
		color: inherit;
	}

	&:disabled {
		align-self: flex-start;
		background-color: inherit;
		color: var(--new-qd--change-method-color);
		opacity: 0.7;
	}
`;
